import React from 'react';
import { graphql } from 'gatsby';
import SEO from '../global/Seo';
import ReactComponentsByDocument from '../utils/ReactComponentsByDocument';
import PageTemplate from '../components/04_templates/default-page-layout';
import FooterSection from '../components/03_organisms/FooterSection/FooterSection';

interface ImprintInterface {
  data: any;
  pageContext: any;
}
const Imprint: React.FC<ImprintInterface> = ({
  data,
  pageContext,
}: ImprintInterface) => {
  return (
    <PageTemplate>
      <>
        <SEO title={data.contentfulPage.title} lang={pageContext.lang} />
        <ReactComponentsByDocument
          document={data.contentfulPage.content.json}
        />
        <FooterSection
          links={[
            {
              label: 'Hinweise zum Datenschutz',
              href: '/privacy-policy/',
            },
            {
              label: 'Impressum',
              href: '/imprint/',
            },
          ]}
        />
      </>
    </PageTemplate>
  );
};

export default Imprint;

export const query = graphql`
  query {
    contentfulPage(
      contentful_id: { eq: "5GwJl3dWvuukK8mYesac62" }
      node_locale: { eq: "de" }
    ) {
      title
      content {
        json
      }
    }
  }
`;
